class Device {
  constructor() {
    this.numpad = true
    this.pluginEvent = null
    this.pluginTV = null
    this.pluginNavi = null
    this.pluginCommon = null

    this.TV_EVENT_TYPE = {
      PL_TV_EVENT_CHANGE_POWER_STATE: 211,
      PL_TV_EVENT_SOURCE_CHANGED: 114,
      PL_TV_EVENT_SOURCE_CONNECTED: 126,
      PL_TV_EVENT_TUNE_SUCCESS: 103
    }
  }
  _init = async () => {
    this.pluginEvent = document.getElementById("pluginEvent")
    this.pluginTV = document.getElementById("pluginTV")
    this.pluginNavi = document.getElementById("pluginNavi")
    this.pluginCommon = document.getElementById("pluginObjectCommon")

    this.pluginEvent.Open("TV", "1.000", "TV")
    this.pluginEvent.OnEvent = (event, id, params) => {
      id = parseInt(id, 10)
      eval("params = " + params)
      this._onEvent(event, id, params)
    }
    this.pluginEvent.Execute("SetEvent", 114)
    this.pluginEvent.Execute("SetEvent", 211)

    this.pluginTV.Open("Network", "1.000", "Network")
    this.pluginTV.Execute("SetSoftAPSecurityKeyAutoGeneration", "0")
    this.pluginTV.Close()

    this.pluginNavi.SetBannerState(1)

    return true
  }

  properties = async () => {
    const properties = {
      mac: null,
      ip: null,
      serial: null,
      firmware: null,
      software: null,
      manufacturer: "Samsung",
      product: null,
      type: "samsung"
    }

    this.pluginTV.Open("Network", "1.000", "Network")
    const activeInterface = this.pluginTV.Execute("GetActiveType")
    properties.mac = this.pluginTV.Execute("GetMAC", activeInterface)
    properties.ip = this.pluginTV.Execute("GetIP", activeInterface)
    this.pluginTV.Close()
    properties.serial = this.pluginNavi.GetDUID(properties.mac)

    this.pluginTV.Open("Device", "1.000", "Device")
    properties.firmware = this.pluginTV.Execute("Firmware")
    this.pluginTV.Close()

    this.pluginTV.Open("NNavi", "1.000", "NNavi")
    properties.software = this.pluginTV.Execute("GetFirmware")
    this.pluginTV.Close()

    this.pluginTV.Open("TV", "1.000", "TV")
    properties.product = this.pluginTV.Execute("GetProductCode", 1)
    this.pluginTV.Close()

    const res = Object.keys(properties).every(key => {
      return properties[key] || false
    })

    return res && properties
  }
  baseUrl = async () => {
    return window.location.origin
  }
  getKeyMap = async () => {
    const tvKey = __._api.TvKey
    return [
      // Controllers
      [tvKey.KEY_LEFT, "left"],
      [tvKey.KEY_UP, "up"],
      [tvKey.KEY_RIGHT, "right"],
      [tvKey.KEY_DOWN, "down"],
      [tvKey.KEY_ENTER, "enter"],
      [tvKey.KEY_RETURN, "back"],
      [tvKey.KEY_EXIT, "exit"],
      [-1, "vol_up"],
      [-1, "vol_down"],
      [-1, "mute"],

      // Player Controller
      [-1, "play"],
      [-1, "pause"],
      [-1, "toggle"],
      [-1, "stop"],
      [-1, "fw"],
      [-1, "rw"],
      [-1, "prev"],
      [-1, "next"],

      // TV
      [tvKey.KEY_CH_UP, "ch_up"],
      [tvKey.KEY_CH_DOWN, "ch_down"],
      [-1, "tv"],
      [-1, "subtitle"],
      [-1, "list"],
      [-1, "epg"],

      // General
      [tvKey.KEY_INFO, "info"],
      [-1, "settings"],
      [-1, "alarm-clock"],
      [-1, "sleep-timer"],
      [tvKey.KEY_SOURCE, "source"],
      [-1, "power"],
      [tvKey.KEY_HOME, "home"],
      [-1, "refresh"],

      [tvKey.KEY_RED, "red"],
      [tvKey.KEY_GREEN, "green"],
      [tvKey.KEY_YELLOW, "yellow"],
      [tvKey.BLUE, "blue"],

      // Numpad
      [tvKey.KEY_0, "numpad", 0],
      [tvKey.KEY_1, "numpad", 1],
      [tvKey.KEY_2, "numpad", 2],
      [tvKey.KEY_3, "numpad", 3],
      [tvKey.KEY_4, "numpad", 4],
      [tvKey.KEY_5, "numpad", 5],
      [tvKey.KEY_6, "numpad", 6],
      [tvKey.KEY_7, "numpad", 7],
      [tvKey.KEY_8, "numpad", 8],
      [tvKey.KEY_9, "numpad", 9],

      // Applications
      [-1, "youtube"],
      [-1, "netflix"],
      [-1, "prime"],
      [-1, "spotify"],
      [-1, "browser"],
      [-1, "cast"],
      [-1, "movies"],
      [-1, "musics"],
      [-1, "usb"]
    ]
  }
  setName = async name => {
    if (!name) return false

    this.pluginTV.Open("Network", "1.000", "Network")
    this.pluginTV.Execute("SetTVName", name)
    this.pluginTV.Close()

    return true
  }
  getName = async () => {
    this.pluginTV.Open("Network", "1.000", "Network")
    const name = this.pluginTV.Execute("GetSoftAPSSID")
    this.pluginTV.Close()
    return name
  }

  /* Register Methods */
  registerKeys = async () => {
    const tvKey = __._api.TvKey

    __._api.Plugin.registKey(tvKey.KEY_HOME)
    __._api.Plugin.registKey(tvKey.KEY_EXIT)
    __._api.Plugin.registKey(tvKey.KEY_BACK)
    __._api.Plugin.registKey(tvKey.KEY_RETURN)
    __._api.Plugin.registKey(tvKey.KEY_MENU)
    __._api.Plugin.registKey(tvKey.KEY_GREEN)
    __._api.Plugin.registKey(tvKey.KEY_SOURCE)

    __._api.Plugin.unregistKey(tvKey.KEY_VOL_UP)
    __._api.Plugin.unregistKey(tvKey.KEY_VOL_DOWN)
    __._api.Plugin.unregistKey(tvKey.KEY_MUTE)
    __._api.Plugin.unregistKey(tvKey.KEY_POWER)

    return true
  }

  /* Volume Management */
  volume = async volume => {
    this.pluginTV.Open("Audio", "1.000", "Audio")
    if (typeof volume === "number") this.pluginTV.Execute("SetVolume", volume)
    let currentVolume = this.pluginTV.Execute("GetVolume")
    this.pluginTV.Close()

    return currentVolume
  }
  mute = async value => {
    if (["boolean", "number"].indexOf(typeof value) >= 0) {
      this.pluginTV.Open("Audio", "1.000", "Audio")
      this.pluginTV.Execute("SetUserMute", value ? 1 : 0)
      this.pluginTV.Close()

      return true
    } else {
      this.pluginTV.Open("Audio", "1.000", "Audio")
      const mute = this.pluginTV.Execute("GetMute")
      this.pluginTV.Close()

      return mute
    }
  }
  maxVolume = async () => {
    return true
  }

  /* Power Management */
  getPowerState = async () => {
    this.pluginTV.Open("TV", "1.000", "TV")
    const powerState = this.pluginTV.Execute("GetPowerState")
    this.pluginTV.Close()

    return powerState ? "on" : "standby"
  }
  powerOn = async () => {
    this.pluginTV.Open("HOTEL", "1.000", "HOTEL")
    this.pluginTV.Execute("SetPowerOn")
    this.pluginTV.Close()
    return true
  }
  standBy = async () => {
    this.pluginTV.Open("HOTEL", "1.000", "HOTEL")
    this.pluginTV.Execute("SetPowerOff")
    this.pluginTV.Close()
    return true
  }
  reboot = async () => {
    this.pluginTV.Open("HOTEL", "1.000", "HOTEL")
    this.pluginTV.Execute("SetPowerReboot")
    this.pluginTV.Close()
    return true
  }
  clearData = async () => {
    return true
  }

  /* Soft AP */
  async getSoftAP() {
    const softAp = {
      ssid: null,
      password: null,
      status: await this.isSoftAPEnabled()
    }

    this.pluginTV.Open("Network", "1.000", "Network")
    softAp.ssid = this.pluginTV.Execute("GetSoftAPSSID")
    softAp.password = this.pluginTV.Execute("GetSoftAPSecurityKey")
    this.pluginTV.Close()

    return softAp
  }
  async enableSoftAP() {
    this.pluginTV.Open("Network", "1.000", "Network")
    this.pluginTV.Execute("EnableSoftAP")
    this.pluginTV.Close()
    return true
  }
  async disableSoftAP() {
    this.pluginTV.Open("Network", "1.000", "Network")
    this.pluginTV.Execute("DisableSoftAP")
    this.pluginTV.Close()
    return true
  }
  async isSoftAPEnabled() {
    this.pluginTV.Open("Network", "1.000", "Network")
    const res = this.pluginTV.Execute("IsSoftAPEnabled")
    this.pluginTV.Close()
    return res == 1 ? true : false
  }
  _onEvent(event, id, params) {
    switch (id) {
      case this.TV_EVENT_TYPE.PL_TV_EVENT_SOURCE_CHANGED:
        var source = params.parm2 || params.param2
        if (![47, 49].includes(source)) _$.handler.emit("sourceEvent", source)
        break
      case this.TV_EVENT_TYPE.PL_TV_EVENT_CHANGE_POWER_STATE:
        _$.handler.emit("powerEvent", params.param1 === 6 ? "standby" : "on")
        break
      default:
        break
    }
  }
}

export default Device
